export default __webpack_public_path__ + "static/media/gas_pump.d3bf3d7f.png";